"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalendarDisplayName = exports.getCalendarNumberById = exports.getCalendarIdByNumber = void 0;
var calendarIdConversionTable = {
    1: "divid",
    3: "booking",
    4: "support",
};
var calendarIdToDisplayName = {
    divid: "Divid",
    booking: "Booking",
    support: "Support",
};
function getCalendarIdByNumber(calendarNumber) {
    var calendarId = calendarIdConversionTable[calendarNumber];
    if (!calendarId) {
        throw new Error("Invalid calendar number");
    }
    return calendarId;
}
exports.getCalendarIdByNumber = getCalendarIdByNumber;
function getCalendarNumberById(calendarId) {
    var conversionEntry = Object.entries(calendarIdConversionTable).find(function (_a) {
        var _b = __read(_a, 2), _number = _b[0], id = _b[1];
        return id === calendarId;
    });
    if (!conversionEntry) {
        throw new Error("Invalid string id");
    }
    var _a = __read(conversionEntry, 2), calendarNumber = _a[0], _calendarId = _a[1];
    return Number(calendarNumber);
}
exports.getCalendarNumberById = getCalendarNumberById;
function getCalendarDisplayName(calendarId) {
    return calendarIdToDisplayName[calendarId];
}
exports.getCalendarDisplayName = getCalendarDisplayName;
//# sourceMappingURL=calendar-id.js.map